import { FormControl, Grid, MenuItem, Select, Typography } from '@mui/material'
import React from 'react'
import styles from './index.module.scss'
interface SimpleDropdownProps {
  name: string
  id?: string
  value?: any
  label?: string
  options: {
    value: any
    label: string
  }[]
  placeholder?: string
  onChange?: any
  required?: boolean
  error?: boolean
  hidePlaceholder?: boolean
  disabled?: boolean
  fullWidth?: boolean
}

const SimpleDropdown = ({
  name,
  id,
  value,
  label,
  placeholder,
  onChange,
  required,
  error,
  options,
  hidePlaceholder = false,
  disabled = false,
  fullWidth = true,
}: SimpleDropdownProps) => {
  return (
    <FormControl variant='standard' fullWidth={fullWidth} className={styles.wrapper}>
      <Grid container alignItems='center'>
        <Grid xs={4}>
          <Typography variant='h4' component='p'>
            <label htmlFor={id}>
              {label}
              {required && (
                <Typography variant='subtitle1' color='red' component='span'>
                  &nbsp;*
                </Typography>
              )}
            </label>
          </Typography>
        </Grid>
        <Grid xs={8}>
          <Select
            error={error}
            variant='outlined'
            fullWidth={fullWidth}
            name={name}
            value={value}
            onChange={onChange}
            displayEmpty={hidePlaceholder === false}
            id={id}
            disabled={disabled}
            // required={required}
            className={!value ? styles.placeholderTextColor : ''}
          >
            {hidePlaceholder === false && (
              <MenuItem
                value=''
                sx={{
                  color: '#f7f6e0',
                  backgroundColor: '#25272B',
                  '&:hover': {
                    backgroundColor: '#25272B',
                  },
                }}
              >
                {placeholder}
              </MenuItem>
            )}

            {options.map((option, i) => {
              return (
                <MenuItem
                  key={i}
                  value={option.value}
                  sx={{
                    color: '#ffff',
                    backgroundColor: '#25272B',
                    '&:hover': {
                      backgroundColor: '#ff3839',
                    },
                  }}
                >
                  {option.label}
                </MenuItem>
              )
            })}
          </Select>
        </Grid>
      </Grid>
    </FormControl>
  )
}

export default SimpleDropdown
